import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Spinner,
  Alert,
  Label,
  InputGroupAddon,
  InputGroup,
} from "reactstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";

// availity-reactstrap-validation
import {
  AvForm,
  AvGroup,
  AvFeedback,
  AvInput,
} from "availity-reactstrap-validation";

// action
import {
  setNewPsw,
  resetForgetPassword,
} from "../../store/auth/forgetpwd/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";
import darkLogo from "../../assets/images/logo-sm-dark.png";

//i18n
import { withTranslation } from "react-i18next";

const ForgetPasswordPage = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { token } = useParams();
  const [pswToken] = useState(token);
  const { mainTheme } = useSelector((state) => state.Layout);
  const { error, success, loading, message } = useSelector(
    (state) => state.ForgetPassword
  );
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(setNewPsw(values, history, `Bearer ${pswToken}`));
  };
  useEffect(() => {
    dispatch(resetForgetPassword());
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/login" className="text-dark">
          <i className="bx bx-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("Password recovery")}
                        </h5>
                        <p>
                          {t(
                            "Check your inbox after the password recovery process"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Tech4H" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/login">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={mainTheme === "dark" ? logo : darkLogo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={handleValidSubmit}
                    >
                      {error && (
                        <Alert color="danger">
                          {error === "Invalid data"
                            ? t("Invalid data")
                            : error === "Your session has expired"
                            ? t("Your session has expired")
                            : error ===
                              "Sorry! the page you are looking for could not be found"
                            ? t(
                                "Sorry! the page you are looking for could not be found"
                              )
                            : error ===
                              "password must be different from the previous"
                            ? t(
                                "password must be different from the previous"
                              )
                            : error ===
                                "Sorry! something went wrong, please contact our support team" &&
                              t(
                                "Sorry! something went wrong, please contact our support team"
                              )}
                        </Alert>
                      )}
                      {success && message && (
                        <Alert color="success">
                          {message === "password changed" &&
                            t("password changed")}
                        </Alert>
                      )}

                      <AvGroup>
                        <Label for="password">{t("New password")}</Label>
                        <InputGroup>
                          <AvInput
                            name="password"
                            type={isVisiblePassword ? "text" : "password"}
                            placeholder={t("New password")}
                            validate={{
                              pattern: {
                                value:
                                  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                errorMessage: t(
                                  "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                ),
                              },
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#2e3548",
                                color: "#bfc8e2",
                                outline: "none",
                                border: "1px solid #32394e",
                                borderRadius: "0 0.25em 0.25em 0",
                                width: "3em",
                                marginLeft: "1px",
                              }}
                              onClick={() =>
                                setIsVisiblePassword(!isVisiblePassword)
                              }
                            >
                              {isVisiblePassword ? (
                                <i className="bx bx-hide"></i>
                              ) : (
                                <i className="bx bx-show"></i>
                              )}
                            </button>
                          </InputGroupAddon>
                          <AvFeedback>
                            {t(
                              "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                            )}
                          </AvFeedback>
                        </InputGroup>
                      </AvGroup>

                      <AvGroup>
                        <Label for="confirmationPassword">
                          {t("Confirm new password")}
                        </Label>
                        <InputGroup>
                          <AvInput
                            name="confirmationPassword"
                            type={
                              isVisibleConfirmPassword ? "text" : "password"
                            }
                            placeholder={t("Confirm new password")}
                            validate={{
                              match: {
                                value: "password",
                                errorMessage: t(
                                  "Passwords do not match, try again."
                                ),
                              },
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#2e3548",
                                color: "#bfc8e2",
                                outline: "none",
                                border: "1px solid #32394e",
                                borderRadius: "0 0.25em 0.25em 0",
                                width: "3em",
                                marginLeft: "1px",
                              }}
                              onClick={() =>
                                setIsVisibleConfirmPassword(
                                  !isVisibleConfirmPassword
                                )
                              }
                            >
                              {isVisibleConfirmPassword ? (
                                <i className="bx bx-hide"></i>
                              ) : (
                                <i className="bx bx-show"></i>
                              )}
                            </button>
                          </InputGroupAddon>
                          <AvFeedback>
                            {t("Passwords do not match, try again.")}
                          </AvFeedback>
                        </InputGroup>
                      </AvGroup>

                      <Row className="form-group">
                        <Col className="text-right">
                          {loading ? (
                            <Button
                              disabled={true}
                              style={{
                                width: "100px",
                                cursor: "no-drop",
                              }}
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              <Spinner
                                size="sm"
                                animation="border"
                                style={{
                                  height: "19px",
                                  width: "19px",
                                }}
                              />
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              type="submit"
                              id="showtoast"
                            >
                              {t("Update")}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Go back to")}{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} Tech4humans.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ForgetPasswordPage);
